const AddSquireIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2783_6861)">
        <path
          d="M-1 2.25C-1 0.455074 0.455075 -1 2.25 -1H13.75C15.5449 -1 17 0.455075 17 2.25V13.75C17 15.5449 15.5449 17 13.75 17H2.25C0.455074 17 -1 15.5449 -1 13.75V2.25ZM8.75 3.75C8.75 3.33579 8.41421 3 8 3C7.58579 3 7.25 3.33579 7.25 3.75V7.25H3.75C3.33579 7.25 3 7.58579 3 8C3 8.41421 3.33579 8.75 3.75 8.75H7.25V12.25C7.25 12.6642 7.58579 13 8 13C8.41421 13 8.75 12.6642 8.75 12.25V8.75H12.25C12.6642 8.75 13 8.41421 13 8C13 7.58579 12.6642 7.25 12.25 7.25H8.75V3.75Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2783_6861">
          <rect width="16" height="16" rx="2" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AddSquireIcon;
